<div class="menu-desktop onlyDesktop">
  <div class="scy-select-contrato">
    <div class="input-select">
      <div class="select">
        <label
          for="slct"
          class="slct"
        >Seleccione su contrato</label>
        <select
          name="slct"
          (change)="ContratoSeleccionado($event)"
          class="slct"
          [(ngModel)]="positionselected"
          required
        >
          <option
            *ngFor="let contrato of contratos; let i = index"
            value={{i}}
          >{{!contrato.Ficticio ? contrato.Codigo + ' - ' + contrato.InmuebleBO.Direccion : 'Facturas Cliente'}}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="menu-wrap">
    <div class="login-top__usuario item-mobile">
      <a
        [routerLink]="['/home/usuario']"
        class="nav-link"
        href="#"
        title=""
      >
        <span class="icono-img">
          <img
            src="assets/images/icons/user.svg"
            class="login-icon"
          >
        </span>
      </a>
      <span class="login-top__usuario__text">
        <span class="sr-only">Usuario:</span></span>
    </div>
    <div class="item-mobile">
      <div class="scy-select-contrato">
        <div class="input-select">
          <div class="select">
            <label
              for="slct"
              class="slct"
            >Seleccione su contrato</label>
            <select
              name="slct"
              (change)="ContratoSeleccionado($event)"
              class="slct"
              [(ngModel)]="positionselected"
              required
            >
              <option
                *ngFor="let contrato of contratos; let i = index"
                value={{i}}
              >{{!contrato.Ficticio ? contrato.Codigo + ' - ' + contrato.InmuebleBO.Direccion : 'Facturas Cliente'}}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <nav aria-label="Menú Principal">
      <ul class="menu-list">
        <li>
          <a
            [routerLink]="['/home/home']"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/factura-grafico.svg">
            </span>
            <span>Resumen</span>
          </a>
        </li>
        <li *ngIf="!esFicticio">
          <a
            [routerLink]="['/home/lecturacontador']"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/speed.svg">
            </span>
            <span>Lectura de contador</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/home/consumofactura']"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/chart.svg">
            </span>
            <span>Consumo y facturas</span>
          </a>
        </li>
        <li *ngIf="!esPagadorOInactivo && !esFicticio">
          <a
            [routerLink]="['/home/domiciliacionFactura']"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/domiciliacion.svg">
            </span>
            <span>Domiciliación de factura</span>
          </a>
        </li>
        <li *ngIf="!esPagadorOInactivo && !esFicticio">
          <a
            [routerLink]="['/home/datoscorrespondencia']"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/correspondencia.svg">
            </span>
            <span>Datos de correspondencia</span>
          </a>
        </li>
        <li *ngIf="!esPagadorOInactivo && !esFicticio">
          <a
            [routerLink]="['/home/simuladorConsumo']"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/consumos.svg">
            </span>
            <span>Simulador de consumos</span>
          </a>
        </li>
        <li class="hidden">
          <a
            [routerLink]="['/home/login']"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/login.svg">
            </span>
            <span>Login</span>
          </a>
        </li>
        <li *ngIf="!esPagadorOInactivo && !esFicticio">
          <a
            [routerLink]="['/home/baja']"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/laptop.svg">
            </span>
            <span>Baja</span>
          </a>
        </li>
        <li class="contacto">
          <a
            [routerLink]="['/home/contact']"
            class="nav-link"
            href="#"
          >
            <span class="menu-img">
              <img src="assets/images/icons/contacto.svg">
            </span>
            <span>Contacto</span>
          </a>
        </li>
        <li class="item-mobile">
          <a href="#">
            <span class="menu-img">
              <img
                src="assets/images/icons/salir.svg"
                class="login-icon"
              >
            </span>
            <span>Salir</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
  <div
    *ngIf="!efactura"
    class="scy-factura"
  >
    <a (click)="_showModalFacturaSubscribe=true">
      <p>¿Aún no recibe la facturación electrónica?
        <span>Fácil, práctico y ecológico</span>
      </p>
      <span class="scy-factura__activar">
        <span>Actívela ahora</span>
        <img src="assets/images/icons/arrow_white.svg">
      </span>
    </a>
  </div>
</div>

<!-- MODAL -->
<sacyr-modal
  [setTemplateRef]="modal_content"
  [showModal]="showModal()"
  (closeModal)="closeModal()"
></sacyr-modal>

<ng-template #modal_content>

  <ng-container *ngIf="_showModalFacturaSubscribe">
    <div id="modal_factura">
      <h2>¿Aún no recibe la factura electrónica?</h2>
      <div class="modal-factura__texto">
        <div class="modal-img col-xs-6">
          <img
            class="big"
            src="assets/images/icons/icono-modal.svg"
            alt=""
          >
        </div>
        <ul class="col-xs-6">
          <li>SIN PAPEL</li>
          <li>No se pierde</li>
          <li>Siempre disponible</li>
          <li>¡Una ayuda adicional si tienes inquilinos!</li>
        </ul>
      </div>
      <div class="modal-factura__button">
        <button
          (click)="subscribirFacturaElectronica()"
          type="button"
          class="btn-default"
        >subscríbase</button>
      </div>
    </div>
  </ng-container>

</ng-template>
